module.exports = __webpack_public_path__ + "img/twitter.dd6f7412.png";